import { messages } from './messages';
import { threads } from './threads';

export const chat = ($http: HttpApi) => ({
  messages: messages($http),
  threads: threads($http),
});
